module.exports = __webpack_public_path__ + "09bb27265ef4ca4b8b02a7c0ce4b539d.jpg";